export const localEnv = {
    SUPPORT_ORIGIN: 'https://app.commlocal.net',
    IGNORE_RULES_TABLE_NAME: 'communicate-ignore-rules-store-LOCAL',
    TRASH_RULES_TABLE_NAME: 'communicate-trash-rules-store-LOCAL',
    SUPPORT_USER_POOL_ID: 'support-user-pool-LOCAL',
    SUPPORT_CLIENT_ID: 'support-client-id-LOCAL',
    PROCESSING_ENVIRONMENT_ID: 'LOCAL',
    SUPPORT_COGNITO_BASE_URL: 'https://app.commlocal.net/support/fake-hosted-ui',
    COMMBOT_SNS_TOPIC_ARN: 'commbot-sns-topic-LOCAL',
    AWS_REGION: 'aws-region-LOCAL',
    DATA_ENVIRONMENT_ID: 'data-environment-id-LOCAL',
    SLACK_COMMUNICATE_DEVOPS_CHANNEL_ID: 'slack-communciate-devops-channel-id-LOCAL',
};
//# sourceMappingURL=local.js.map